'use client';

import { useDecisions } from '../../../hooks';
import { useMedalliaForm } from './use-medallia-form';
import { useMedalliaFormV2 } from './use-medallia-form-v2';

export function useMedalliaFeedback() {
    const isOneTrust = useDecisions('onetrust');
    const legacyForm = useMedalliaForm({ isActive: !isOneTrust });
    const formV2 = useMedalliaFormV2({ isActive: isOneTrust });

    return isOneTrust ? formV2 : legacyForm;
}
